import SelectObject from "../../assets/SelectObject";
import DadataApi from "../../api/dadata"
import * as constants from "../../assets/constants";
import {RichCell} from "@vkontakte/vkui";
import React from "react";

class DadataKlientsSelectObject extends SelectObject {

    getItems = (search_ = '') => {

        const search = search_ ? search_ : this.state.search

        this.setState({loading: true, items: []})
        if(search == ''){
            this.setState({loading: false})
            return
        }



        DadataApi.suggestCompany({query: search}, this.props.params ?? '',
        ).then(response => {
            this.setState({loading: false})
            const {data} = response
            const items = []


            data.map((el, i) => {
                el.name = el.value
                el.uid = el.data.inn
                el.id = el.data.inn
                el.address = el.data.address ? (el.data.address.unrestricted_value ?? '') : ''
                el.descr = el.data.inn
                items.push(el)
            })

            this.setState({items})
        })


    }


    showList = () => {
        this.setState({showSearch: true})
        this.setActiveModal(constants.MODAL_LIST_OBJECTS)
    }
    renderRow = (item, index, last_store_klients_id = null) => {
        return <RichCell key={'obj' + index} onClick={() => this.selectObject(index)} multiline
                         style={{border: item.external_id == last_store_klients_id ? '1px solid orange' : 'inherit'}}
                         caption={item.address}
                         subhead={item.descr}
        >
            {item.name}
        </RichCell>
    }


}

export default DadataKlientsSelectObject